<script setup>
	import { onMounted, ref } from 'vue'
  import MediaModal from "@/components/home/MediaModal.vue";
	import CardContainer from "@/components/home/HomeCardContainer.vue";
	import AboutIndicators from "@/components/home/AboutIndicators.vue";
  import TrendingContainer from "@/components/home/TrendingContainer.vue";
  import TutorialsContainer from "@/components/home/TutorialsContainer.vue";
	import HomeSearch from "@/components/home/HomeSearch.vue";
	import BannerMsg from "@/components/common/BannerInfo.vue"
  import "@/components/accessibility/accessibility.js";


	//reactive field proxies
	const showBanner = ref(false)
	const bannerMsg = ref('')
	const bannerType = ref('')
  
	const showMediaModal = ref(false)

  //reactive field proxies
	const title = ref('null')
	const poster = ref('null')
	const source = ref('null')
	const description = ref('null')
	const indicator = ref('null')

	//Methods
	async function getText(file) {
		let x = await fetch(file);
		let y = await x.text();
		let cardObj = JSON.parse(y);

		title.value = cardObj.title
		source.value = import.meta.env.VITE_BASE_URL + cardObj.filePath
		poster.value = import.meta.env.VITE_BASE_URL + cardObj.poster
		//description.value = cardObj.description
		//indicator.value = encodeURIComponent(cardObj.indicator)
	}

  //local variables
	const isSmallScreen = () => window.innerWidth <= 1279;

  function closeMediaModal() {
		showMediaModal.value = false
	}
  function openMediaModal() {
		//if(isSmallScreen) toggleMenu()
		showMediaModal.value = true
	}	

	onMounted(() => {
		const historyState = window.history.state
		if (historyState && historyState.msgObj) {
			bannerMsg.value = historyState.msgObj.text
			bannerType.value = historyState.msgObj.type
			showBanner.value = true;
		}
    // Digital Analytics Program (https://digital.gov/guides/dap) 
    if(import.meta.env.VITE_APP_ENV && import.meta.env.VITE_APP_ENV === 'production') {
        const dapScript = document.createElement("script");
            dapScript.setAttribute("async", "")
            dapScript.setAttribute("id","_fed_an_ua_tag");
            dapScript.setAttribute("type","text/javascript");
            dapScript.setAttribute("src","https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js?agency=NSF");
        document.head.appendChild(dapScript);
    }
   	//initial method run on page load
    let url = import.meta.env.VITE_BASE_URL + "/json/videoCardShortIntro.json"
    getText(url);
	})

</script>

<template>
	<div id="home-pg-msg-container">
		<BannerMsg :show="showBanner" :type="bannerType" :msgContent="bannerMsg"></BannerMsg>
	</div>
  <div class="page-container">

    <div class="container"></div> 

    <h4 class="umbrella-title">National Center for Science and Engineering Statistics</h4>

    <h1 class="title">Indicators Explorer</h1>
    
    <div class="intro-media-container">
      <div class="intro-media-link" @click="openMediaModal" @keydown.enter="openMediaModal" :title="title" role="link" tabindex="0">
        <span class="text-gap"><i class="fa-solid fa-play-circle"></i></span>
        <span class="underline-part">Watch a video about Indicators Explorer</span>
      </div>
    </div>

    <MediaModal 
        :isOpen="showMediaModal" 
        :source="source"
        :poster="poster"
        @closeMediaModal="closeMediaModal" />

    <HomeSearch />
    
    <CardContainer />
        
  </div>

  <div class="bottom-page">
      <AboutIndicators />
      <!-- <TrendingContainer /> -->
      <TutorialsContainer />
  </div>


</template>

<style scoped>

  #home-pg-msg-container {
	  margin-bottom: 1.25rem;
  }
  #home-pg-msg-container:empty {
    display: none;
  }
  .page-container {
    background-color: var(--surface-color-Secondary);
  }
  .container {
    display: block;
    width: 100%;
    padding: 8rem 0;
    margin-bottom: -70vh;
    
    justify-content: center;
    border-radius: 0.75rem;
    /*
    background: linear-gradient(0deg, var(--surface-brand-black, rgba(0, 0, 0, 0.40)) 0%, var(--surfaces-surface-brand-black, rgba(0, 0, 0, 0.40)) 100%), url("@/assets/images/hero.jpg") lightgray -145.547px -17.522px / 118.974% 102.434% no-repeat;
    */    
    background-image: url("@/assets/images/Hero-Indicators-Medium-v1-Compressed.jpg");
    background-color: var(--surface-color-Secondary);
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.10);

     /* Full height */
    height: 83vh;
    min-height: 43.75rem;

    /* Create the parallax scrolling effect */
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .bottom-page {
    background-color: var(--surface-color-Default);
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  h1 {
	margin:0;
  }
  .umbrella-title {
    font-family: var(--font-family-Title, Roboto);
    font-size: var(--font-size-H4);
    text-align: center;
    color: var(--text-Inverse);
    font-weight: var(--font-weight-Bold); /*700*/
    line-height: var(--font-line-height-H4);
    margin-bottom: 0;
  }
  .title {
    font-family: var(--font-family-Title, Roboto);
    font-size: var(--font-size-Hero, 76px);
    text-align: center;
    color: var(--text-Inverse);
    font-weight: var(--font-weight-Bold);
    line-height: var(--font-line-height-Hero);
  }
  .intro-media-container {
    display: flex;
    justify-content: center; /* Centers horizontally along the main axis */
  }
  .intro-media-link {
    /* style="color: white; margin-left: auto; margin-right: auto; text-align: center;" */
    font-family: var(--font-family-Title, Roboto);
    
    color: var(--text-Inverse);
    font-size: var(--font-size-H6);
    font-weight: var(--font-weight-Medium);
    line-height: var(--font-line-height-Hero);
    cursor: pointer;
  }
  .underline-part {
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-offset: 0%;
    text-decoration-thickness: 0%;
    text-decoration-skip-ink: auto;
  }
  .text-gap {
    margin-right: .5rem;
  }
@media screen and (min-width: 799px) and (max-width: 1200px) {
	.container {
    padding: 0 0;
    margin-bottom: -85vh;
  }
}
@media screen and (min-width: 1201px) and (max-width: 1748px) {
.container {
    padding: 0 0;
    margin-bottom: -75vh;
  }
}
@media screen and (min-width: 1749px) and (max-width: 199999px) {
.container {
    padding: 8rem 0;
    margin-bottom: -70vh;
  }
}

/*  #main-content {
     display: grid;
    grid-template-columns: 1fr 1fr;
    gap: .5rem;
    max-width: 1280px;
    width:100%;
    margin: 0 auto;
    padding: 2rem;
    font-weight: normal;   
    
    border: 1px solid #ccc;
  }

  @media (max-width: 1023px) {
    body {
      display: flex;
      place-items: center;
    }

    #main-content {
      display:inline-block;
    }
  } */
</style>
